// extracted by mini-css-extract-plugin
export default {"title":"mainStackItem_title__0tok2","mainStackItem":"mainStackItem_mainStackItem__4qpQc"};